<nav>
  <ul class="breadcrumb">
    <li class="breadcrumb-item"><a href="#" (click)="goBack($event)"><i class="fa fa-arrow-circle-left" style="width: 20px;"></i>Back to Search Results</a></li>
    <li class="ms-auto">
      @if (externalLinks) {
      <a [href]="externalLinks.dataBankResourcesUrl" target="_blank"><i class="fa fa-external-link" style="width: 20px;"></i>DNA Data Bank Resources</a>
      }
    </li>
  </ul>
</nav>
<div class="text-center">
  <h1>DNA Sample Correction</h1>
</div>
@if (errorMessage) {
  <div class="col-12 col-lg-6 offset-lg-3 alert alert-danger">{{errorMessage}}</div>
}
@if (data) {
<div>
  <form id="createSampleCorrectionForm" #createSampleCorrectionForm="ngForm" sampleCorrectionValidator>
    <div class="row">
      <p class="text-center col-12 offset-md-2 col-md-8">Enter one or more corrections to the sample information.</p>
    </div>
    <div class="row mb-2">
      <label for="last-name" class="col-12 offset-md-2 col-md-8 col-xl-2">Last Name</label>
      <div class="col-12 offset-md-2 col-md-4 offset-xl-0 col-xl-3 bold-label">{{ data.lastName }}</div>
      <div class="col-12 col-md-4 col-xl-3">
        <input type="text" id="last-name" name="lastName" class="form-control" maxlength="50" [(ngModel)]="lastName" oninput="this.value = this.value.toUpperCase()" />
      </div>
    </div>
    <div class="row mb-2">
      <label for="first-name" class="col-12 offset-md-2 col-md-8 col-xl-2">First Name</label>
      <div class="col-12 offset-md-2 col-md-4 offset-xl-0 col-xl-3 bold-label">{{ data.firstName }}</div>
      <div class="col-12 col-md-4 col-xl-3">
        <input type="text" id="first-name" name="firstName" class="form-control" maxlength="25" [(ngModel)]="firstName" oninput="this.value = this.value.toUpperCase()" />
      </div>
    </div>
    <div class="row mb-2">
      <label for="middle-initial" class="col-12 offset-md-2 col-md-8 col-xl-2">Middle Initial</label>
      <div class="col-12 offset-md-2 col-md-4 offset-xl-0 col-xl-3 bold-label">{{ data.middleInitial }}</div>
      <div class="col-12 col-md-4 col-xl-3">
        <input type="text" id="middle-initial" name="middleInitial" class="form-control" maxlength="1" [(ngModel)]="middleInitial" oninput="this.value = this.value.toUpperCase()" />
      </div>
    </div>
    <div class="row mb-2">
      <label for="suffix" class="col-12 offset-md-2 col-md-8 col-xl-2">Suffix</label>
      <div class="col-12 offset-md-2 col-md-4 offset-xl-0 col-xl-3 bold-label">{{ data.suffix }}</div>
      <div class="col-12 col-md-4 col-xl-3">
        <select id="suffix" name="suffix" class="form-select" [(ngModel)]="suffix">
          <option [ngValue]="undefined"></option>
          @for (suffix of data.suffixes; track suffix) {
          <option [ngValue]="suffix">{{ suffix }}</option>
          }
        </select>
      </div>
    </div>
    <div class="row mb-2">
      <label for="alias" class="col-12 offset-md-2 col-md-8 col-xl-2">Alias</label>
      <div class="col-12 offset-md-2 col-md-4 offset-xl-0 col-xl-3 bold-label">{{ data.aliases }}</div>
      <div class="col-12 col-md-4 col-xl-3">
        <input type="text" id="alias" name="alias" class="form-control" maxlength="50" [(ngModel)]="alias" oninput="this.value = this.value.toUpperCase()" />
      </div>
    </div>
    <div class="row mb-2">
      <label for="gender" class="col-12 offset-md-2 col-md-8 col-xl-2">Gender</label>
      <div class="col-12 offset-md-2 col-md-4 offset-xl-0 col-xl-3 bold-label">{{ data.gender }}</div>
      <div class="col-12 col-md-4 col-xl-3">
        <select id="gender" name="gender" class="form-select" [(ngModel)]="genderCode">
          <option [ngValue]="undefined"></option>
          @for (gender of data.genders; track gender) {
          <option [ngValue]="gender.code">{{ gender.name }}</option>
          }
        </select>
      </div>
    </div>
    <div class="row mb-2">
      <label for="race" class="col-12 offset-md-2 col-md-8 col-xl-2">Race</label>
      <div class="col-12 offset-md-2 col-md-4 offset-xl-0 col-xl-3 bold-label">{{ data.race }}</div>
      <div class="col-12 col-md-4 col-xl-3">
        <select id="race" name="race" class="form-select" [(ngModel)]="raceId">
          <option [ngValue]="undefined"></option>
          @for (race of data.races; track race) {
          <option [ngValue]="race.id">{{ race.name }}</option>
          }
        </select>
      </div>
    </div>
    <div class="row mb-2">
      <label for="date-of-birth" class="col-12 offset-md-2 col-md-8 col-xl-2">Date of Birth</label>
      <div class="col-12 offset-md-2 col-md-4 offset-xl-0 col-xl-3 bold-label">{{ data.dateOfBirth | date: 'M/d/yyyy' }}</div>
      <div class="col-12 col-md-4 col-xl-3">
        <div class="input-group">
          <input type="text" id="date-of-birth" name="dateOfBirth" placeholder="mm/dd/yyyy" class="form-control" ngbDatepicker [maxDate]="today" #dobPicker="ngbDatepicker" #dateOfBirthControl="ngModel" [(ngModel)]="dateOfBirth" [class.is-invalid]="showValidation && !dateOfBirthControl.valid" />
          <div class="input-group-append">
            <button class="btn btn-outline-secondary text-dropdown" (click)="dobPicker.toggle()" type="button"><i class="fa fa-calendar"></i></button>
          </div>
        </div>
        @if (showValidation && dateOfBirthControl.hasError('ngbDate') && dateOfBirthControl.getError('ngbDate')?.invalid) {
        <small class="text-danger">Date of Birth must be in the format: mm/dd/yyyy</small>
        }
        @if (showValidation && dateOfBirthControl.hasError('ngbDate') && dateOfBirthControl.getError('ngbDate')?.requiredAfter) {
        <small class="text-danger">Date of Birth must not be in the future</small>
        }
      </div>
    </div>
    <div class="row mb-2">
      <label for="ssn" class="col-12 offset-md-2 col-md-8 col-xl-2">SSN</label>
      <div class="col-12 offset-md-2 col-md-4 offset-xl-0 col-xl-3 bold-label">{{ data.ssns }}</div>
      <div class="form-group col-12 col-md-4 col-xl-3 mb-0">
        <input type="text" id="ssn" name="ssn" mask="000-00-0000" [dropSpecialCharacters]="false" class="form-control" #ssnControl="ngModel" [(ngModel)]="ssn" [class.is-invalid]="showValidation && !ssnControl.valid" (keydown.tab)="ssnKeyDown($event)" />
        @if (showValidation && !ssnControl.valid) {
        <small class="text-danger">SSN must be in the format: 000-00-0000</small>
        }
      </div>
    </div>
    <div class="row mb-2">
      <label for="sid" class="col-12 offset-md-2 col-md-8 col-xl-2">SID</label>
      <div class="col-12 offset-md-2 col-md-4 offset-xl-0 col-xl-3 bold-label">{{ data.sid }}</div>
      <div class="col-12 col-md-4 col-xl-3">
        <input type="text" id="sid" name="sid" class="form-control" maxlength="11" #sidTextbox [(ngModel)]="sid" oninput="this.value = this.value.toUpperCase()" />
      </div>
    </div>
    @if (showVACORISNumber) {
    <div class="row mb-2">
      <label for="doc-number" class="col-12 offset-md-2 col-md-8 col-xl-2">VACORIS #</label>
      <div class="col-12 offset-md-2 col-md-4 offset-xl-0 col-xl-3 bold-label">{{ data.docNumber }}</div>
      <div class="col-12 col-md-4 col-xl-3">
        <input type="text" id="doc-number" name="docNumber" class="form-control" maxlength="11" [(ngModel)]="docNumber" oninput="this.value = this.value.toUpperCase()" />
      </div>
    </div>
    }
    @if (showValidation && createSampleCorrectionForm.errors?.noRequiredFields) {
    <div class="row">
      <small class="col-12 offset-md-2 col-md-8 text-danger text-md-right">You must enter at least one correction.</small>
    </div>
    }
    <div class="row mb-2">
      <label for="reason" class="col-12 offset-md-2 col-md-8">Reason</label>
      <div class="col-12 offset-md-2 col-md-8">
        <input type="text" id="reason" name="reason" class="form-control" maxlength="200" [(ngModel)]="reason" />
      </div>
    </div>
    <div class="row">
      <div class="col-12 offset-md-2 col-md-8">
        <button type="button" class="btn btn-primary float-end" [disabled]="working || !createSampleCorrectionForm.form.dirty" (click)="onSubmit()">Submit</button>
        @if (working) {
        <div class="wait float-end me-2 mt-1"><i class="fa fa-spinner fa-spin" aria-hidden="true"></i></div>
        }
      </div>
    </div>
    <div class="row">
      @if (showThanks) {
      <div class="col-12 offset-md-2 col-md-8">
        <h4 class="mt-4">Thank You!</h4>
        <p>Your correction(s) have been submitted, and will be reviewed by the DNA Data Bank team.</p>
      </div>
      }
    </div>
  </form>
</div>
}
